import { useDebounceFn } from '@umijs/hooks';

import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useGettingLogs = () => {
  const { onSubmit: logsRequest } = useFetch('logs-request', Api.LOGS);
  const { response: logs, onFetch } = useFetch('logs', Api.LOGS);

  const { run: onLogsRequest } = useDebounceFn(
    (id) =>
      logsRequest({
        method: 'POST',
        pathParams: { id },
        onSuccess: () => {
          onFetch({ pathParams: { id } });
        },
      }),
    [],
    300
  );

  const onFetchLogs = (id) => onFetch({ pathParams: { id } });

  return {
    logs,
    onLogsRequest,
    onFetchLogs,
  };
};

export default useGettingLogs;
